import { render, staticRenderFns } from "./DeleteTagModal.vue?vue&type=template&id=796aa276"
import script from "./DeleteTagModal.vue?vue&type=script&lang=js"
export * from "./DeleteTagModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports